export const PROFILEIDS = {
  adminGroupSoftware: 1,
  adminMaster: 2,
  admin: 3,
  surveyor: 4
};
